var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container editor-container",class:{fullscreen:_vm.fullscreen}},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}}),_c('div',{staticClass:"editor-custom-btn-container"},[_c('editorImage',{staticClass:"editor-upload-btn",attrs:{"color":"#20a0ff"},on:{"successCBK":_vm.imageSuccessCBK}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }